import { types } from 'mobx-state-tree';


const LIVING_SPACE_UNITS = {
    SQUARE_FEET: 'sq-ft',
    SQUARE_METERS: 'sq-m',
};

const LivingSpaceUnitEnum = types.enumeration('LivingSpaceUnit', Object.values(LIVING_SPACE_UNITS));

export {
    LivingSpaceUnitEnum,
};
export default LIVING_SPACE_UNITS;